const ethnicity = {
  Hispanic: 1,
  White: 2,
  Black: 3,
  Native: 4,
  SouthAsian: 5,
  Asian: 6,
  Other: 7,
  Unknown: 8
}

export default ethnicity;